export default {
    patient: state => state.patient,
    patientsAndOwners: state => state.patientsAndOwners,
    owner: state => state.owner,
    prescriptions: state => state.prescriptions
}